import React from "react";
import { motion } from "framer-motion";

const Approach = () => {
  return (
    <section className="hob-approach-section">
      <motion.div
        className="hob-approach-card"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <h2 className="hob-approach-title">My Approach</h2>
        <p className="hob-approach-text">
          I tailor each intervention to the unique needs of my clients,
          offering a safe, supportive, & transformative environment where they
          can explore their challenges & discover their inner strengths. <br />
          <br />
          My goal is to facilitate healing & guide clients toward personal
          growth & self-discovery.
        </p>
      </motion.div>
    </section>
  );
};

export default Approach;
